import styled from 'styled-components';
import { FiChevronDown, FiUser } from 'react-icons/fi';


export const UserProfileBlueGray = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  padding: 0 12px;
  width: 15vw;
  border-radius: 24px;
  height: 48px;
  
  @media (max-width: 768px) {
    width: auto;
    min-width: 120px;
    max-width: 150px;
    padding: 0 8px;
  }
`;
export const AvatarBlueGray = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #4A5568;
  color: #F3F4F6;
  border-radius: 50%;
  font-size: 1.2rem;
  font-weight: 600;
  margin-right: 10px;
  flex-shrink: 0;
  overflow: hidden;

  img { width: 100%; height: 100%; object-fit: cover; }
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 1rem;
    margin-right: 6px;
  }
`;
export const UserTextBlueGray = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #F3F4F6;
  font-size: 1.08rem;
  font-weight: 400;
  letter-spacing: 0.1px;
  span {
    color: #F3F4F6;
    font-weight: 700;
    margin-left: 2px;
    margin-right: 4px;
  }
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    
    span {
      margin-left: 1px;
      margin-right: 2px;
    }
  }
`;

export const CompanyTextBlueGray = styled.div`
  color: #CBD5E1;
  font-size: 12px;
  line-height: 1.1;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;

  @media (max-width: 768px) {
    max-width: 120px;
  }
`;


export const UserProfileGraphite = styled.div`
  display: flex;
  align-items: center;
  background: #3A3E55;
  padding: 0 12px;
  height: 48px;
`;
export const AvatarGraphite = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #6B7280;
  color: #E5E7EB;
  border-radius: 50%;
  font-size: 1.2rem;
  font-weight: 600;
  margin-right: 10px;
`;
export const UserTextGraphite = styled.div`
  display: flex;
  align-items: center;
  color: #E5E7EB;
  font-size: 1.08rem;
  font-weight: 400;
  letter-spacing: 0.1px;
  span {
    color: #E5E7EB;
    font-weight: 700;
    margin-left: 2px;
    margin-right: 4px;
  }
`;

// 3. Contraste suave com azul petróleo
export const UserProfilePetrol = styled.div`
  display: flex;
  align-items: center;
  background: #243447;
  padding: 0 12px;
  height: 48px;
`;
export const AvatarPetrol = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #374151;
  color: #F9FAFB;
  border-radius: 50%;
  font-size: 1.2rem;
  font-weight: 600;
  margin-right: 10px;
`;
export const UserTextPetrol = styled.div`
  display: flex;
  align-items: center;
  color: #F9FAFB;
  font-size: 1.08rem;
  font-weight: 400;
  letter-spacing: 0.1px;
  span {
    color: #F9FAFB;
    font-weight: 700;
    margin-left: 2px;
    margin-right: 4px;
  }
`;

export const IconUser = styled(FiUser)`
  width: 22px;
  height: 22px;
  color: inherit;
`;

export const DropdownIcon = styled(FiChevronDown)`
  width: 18px;
  height: 18px;
  color: inherit;
  margin-left: 2px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
    margin-left: 1px;
  }
`;